<template>
  <a-drawer width="35%" placement="right" :closable="false" :visible="openView" @close="onCloseView">
    <a-descriptions :title="$t('monitor.operlog.viewOperInfo')" layout="vertical">
      <a-descriptions-item :label="$t('monitor.operlog.operModule')">
        {{ displayTitle }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.loginInfo')">
        {{ form.operName }} / {{ form.operIp }} / {{ form.operLocation }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.requestUrl')">
        {{ form.operUrl }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.operMethod')" span="2">
        <div style="word-break: break-all;">{{ form.method }}</div>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.requestMethod')">
        {{ form.requestMethod }}
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions :title="$t('monitor.operlog.apiInfo')" layout="vertical">
      <a-descriptions-item :label="$t('monitor.operlog.requestParam')" span="3">
        {{ form.operParam }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.responseParam')" span="3">
        {{ form.jsonResult }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.operStatus')" span="1">
        <a-badge v-if="form.status === 1" status="processing" :text="$t('monitor.operlog.statusNormal')" />
        <a-badge v-if="form.status === 0" status="error" :text="$t('monitor.operlog.statusFail')" />
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.operDate')" span="1">
        {{ parseTime(form.operTime) }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('monitor.operlog.errorMsg')" span="3" v-if="form.status === 1">
        {{ form.errorMsg }}
      </a-descriptions-item>
    </a-descriptions>
  </a-drawer>
</template>

<script>
import { formatOperlogTitle } from '@/utils/operlogTitle'

export default {
  name: 'ViewForm',
  props: {
  },
  data () {
    return {
      form: {},
      openView: false
    }
  },
  computed: {
    displayTitle () {
      return formatOperlogTitle(this.form.title, this.$t.bind(this))
    }
  },
  methods: {
    handleView (row) {
      this.openView = true
      this.form = row
    },
    onCloseView () {
      this.openView = false
    }
  }
}
</script>
